<template>
    <main>
        <template v-if="!isApp">
            <cloud-entry v-if="isCloudHomePage" />
            <old-entry v-else />
        </template>
        <router-view></router-view>
    </main>
</template>

<script lang="ts">
import Vue from 'vue';
import OldEntry from './components/OldEntry.vue';
import CloudEntry from './components/CloudEntry.vue';
import { isApp } from '@/utils/business';

export default Vue.extend({
    components: {
        OldEntry,
        CloudEntry
    },
    computed: {
        isCloudHomePage(): boolean {

            return this.$route.name === 'cloud-plan';

        },
        isApp(): boolean {

            return isApp;

        }
    }
});
</script>

<style lang="less">
.tip-link{
    font-size: 16px;
}
</style>
